import { Injectable } from '@angular/core';
import { PaymentManagerService } from './payment-manager.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentPresenterService {

  constructor(
    private paymentManagerService: PaymentManagerService
  ) { }

  dueDate(effectiveDate: string) {
      /*
          Requires an effective Date to be able to
          determine the due date. This should be a string
          like so 1/1/2014 not a date object
      */
      const splitEffDate = effectiveDate.split('/');
      const effectiveMonth = Number(splitEffDate[0]);
      const effectiveYear = Number(splitEffDate[2]);
      const effectiveDay = Number(splitEffDate[1]);

      const dueDate = new Date(effectiveYear, effectiveMonth - 1, effectiveDay - 1);

      return dueDate.getMonth() + 1 + '/' + dueDate.getDate() + '/' + dueDate.getFullYear();
  }
  creditCardType() {
      const paymentData = this.paymentManagerService.getPaymentData();
      return paymentData.cardInfo.ccType;
  }
  creditCardNumber() {
      const paymentData = this.paymentManagerService.getPaymentData();
      return paymentData.cardInfo.ccNumEnc;
  }
  maskedCreditCardNumber () {
      const paymentData = this.paymentManagerService.getPaymentData();
      return paymentData.cardInfo.ccNumEnc.replace(/\d(?=\d{4})/g, '*');
  }
  expirationDate() {
      const paymentData = this.paymentManagerService.getPaymentData();
      return paymentData.cardInfo.ccExpDt.substr(0, 2) + '/' + '20' + paymentData.cardInfo.ccExpDt.substr(2,3);
  }
  routingNumber() {
      const paymentData = this.paymentManagerService.getPaymentData();
      return paymentData.achInfo.custSubBankID;
  }
  accountNumber() {
      const paymentData = this.paymentManagerService.getPaymentData();
      return paymentData.achInfo.custSubAcctNumEnc;
  }
  maskedAccountNumber () {
      const paymentData = this.paymentManagerService.getPaymentData();
      return paymentData.achInfo.custSubAcctNumEnc.replace(/\d(?=\d{4})/g, '*');
  }
  billingName() {
      const paymentData = this.paymentManagerService.getPaymentData();
      return paymentData.billingAddress.name;
  }
  billingAddress() {
      const paymentData = this.paymentManagerService.getPaymentData();
      return this._address(paymentData.billingAddress);
  }
  _address(address) {
      let text = '';

      if (address) {

          if (address.addr1) {
              text += address.addr1 + '<br>';
          }

          if (address.addr2) {
              text += address.addr2 + '<br>';
          }

          if (address.city) {
              text += address.city + ', ';
          }

          if (address.state) {
              text += address.state + ' ';
          }

          if (address.zip) {
              text += address.zip;
          }
      }

      return text;
  }
}
